"use strict";
import React from "react";
import _ from "underscore";
import Autolinker from "autolinker";
import DOMPurify from "dompurify";
var SimpleHtmlFormat = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "SimpleHtmlFormat" }, _.map(this.paragraphs(), this.paragraph));
  },
  paragraph: function(para, index) {
    return /* @__PURE__ */ React.createElement("p", { key: "paragraph_" + index }, _.map(this.lines(para), this.line));
  },
  lines: function(text) {
    return text.split("\n");
  },
  paragraphs: function() {
    var withoutCRs = (this.props.text || "").replace(/\r\n|\r/g, "\n");
    return withoutCRs.split("\n\n");
  },
  line: function(text, idx) {
    var br = /* @__PURE__ */ React.createElement("br", null);
    const textWithFixedAngleBrackets = text.replace(
      /<([^<> ]*[.:][^<> ]*)>/g,
      (match, betweenAngleBrackets) => `&lt;${betweenAngleBrackets}&gt;`
    );
    const sanitizedText = DOMPurify.sanitize(textWithFixedAngleBrackets, {
      USE_PROFILES: { html: true }
    });
    const linkedText = Autolinker.link(sanitizedText, { newWindow: true });
    const sanitizedLinkedText = DOMPurify.sanitize(linkedText, {
      USE_PROFILES: { html: true }
    });
    return /* @__PURE__ */ React.createElement("span", { key: "line_" + idx }, /* @__PURE__ */ React.createElement("span", { dangerouslySetInnerHTML: { __html: sanitizedLinkedText } }), " ", idx === 0 ? "" : br);
  }
});
export default SimpleHtmlFormat;
